import { useEffect, useReducer, useState } from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "react-bootstrap";

let initialValue = {
  kode: "",
  judul: "",
  durasi: "",
  tanggal: "",
  tanggalAssessment: "",
  lokasi: "",
  instructor: "",
  selectedUk: null,
  userName: "",
  ukList: [],
};
const reducer = (state, action) => {
  switch (action.type) {
    case "kode":
      return { ...state, kode: action.value };
    case "judul":
      return { ...state, judul: action.value };
    case "durasi":
      return { ...state, durasi: action.value };
    case "tanggal":
      return { ...state, tanggal: action.value };
    case "tanggalAssessment":
      return { ...state, tanggalAssessment: action.value };
    case "lokasi":
      return { ...state, lokasi: action.value };
    case "instructor":
      return { ...state, instructor: action.value };
    case "selectedUk":
      return { ...state, selectedUk: action.value };
    case "userName":
      return { ...state, userName: action.value };
    case "ukList":
      return { ...state, ukList: action.value };
    case "RESET_STATE":
      return initialValue;
    default:
      break;
  }
};
/**
 *
 * @param {{
 * show:boolean,
 * onHide:()=>void,
 * submitClick:({
 *  kode:string,
 *  judul:string,
 *  durasi:string,
 *  tanggal:string,
 *  tanggalAssessment:string,
 *  lokasi:string,
 *  instructor:string,
 *  selectedUk:integer,
 *  userName:string,
 *  ukList:array
 * })=>void,
 * data:{
 *  mainData:{
 *      tanggal:string,
 *      lokasi:string,
 *      instructor:string,
 *  },
 *  uks?:array<{ukId:integer,title:string}>,
 *  userName?:string | null
 * }
 * }} props
 * @returns {JSX.Element}
 */

function ModalAmiReport({
  show = false,
  onHide,
  submitClick,
  data = {
    mainData: {
      tanggal: "",
      lokasi: "",
      instructor: "",
    },
    uks: [],
    userName: "",
  },
}) {
  const [values, dispatch] = useReducer(reducer, initialValue);

  const [uk, setUk] = useState([]);

  useEffect(() => {
    if (!show) return;
    const { mainData, uks, userName } = data;
    dispatch({ type: "tanggal", value: mainData.tanggal });
    dispatch({ type: "durasi", value: "3 Jam" });
    dispatch({ type: "tanggalAssessment", value: mainData.tanggal });
    dispatch({ type: "lokasi", value: mainData.lokasi });
    dispatch({ type: "instructor", value: mainData.instructor });
    dispatch({
      type: "selectedUk",
      value: uks.length === 1 ? uks[0].id : null,
    });
    dispatch({ type: "userName", value: userName });
    dispatch({ type: "ukList", value: uks });
    setUk(uks);
  }, [show]);

  const submitDisable = !values.judul || values.selectedUk == null || !values.lokasi || !values.instructor;

  return (
    <>
      <Modal show={show} onHide={() => onHide()}>
        <ModalHeader closeButton>
          <h5 className="modal-title">Will anything be changed?</h5>
        </ModalHeader>
        <ModalBody>
          <div className="row mb-3">
            <label className="col-sm-2 col-form-label" htmlFor="kode">
              Kode
            </label>
            <div className="col-sm-10">
              <input onChange={(e) => dispatch({ type: "kode", value: e.target.value })} type="text" className="form-control" id="kode" />
            </div>
          </div>
          <div className="row mb-3">
            <label className="col-sm-2 col-form-label" htmlFor="judul">
              Judul
            </label>
            <div className="col-sm-10">
              <input onChange={(e) => dispatch({ type: "judul", value: e.target.value })} type="text" className="form-control" id="judul" />
            </div>
          </div>
          <div className="row mb-3">
            <label className="col-sm-2 col-form-label" htmlFor="durasi">
              Durasi
            </label>
            <div className="col-sm-10">
              <input value={values.durasi} onChange={(e) => dispatch({ type: "durasi", value: e.target.value })} type="text" className="form-control" id="durasi" />
            </div>
          </div>
          <div className="row mb-3">
            <label className="col-sm-2 col-form-label" htmlFor="tanggal">
              Tanggal
            </label>
            <div className="col-sm-10">
              <input value={values.tanggal} onChange={(e) => dispatch({ type: "tanggal", value: e.target.value })} type="date" className="form-control" id="tanggal" />
            </div>
          </div>
          <div className="row mb-3">
            <label className="col-sm-2 col-form-label" htmlFor="tanggalAss">
              Tanggal Ass.
            </label>
            <div className="col-sm-10">
              <input value={values.tanggalAssessment} onChange={(e) => dispatch({ type: "tanggalAssessment", value: e.target.value })} type="date" className="form-control" id="tanggalAss" />
            </div>
          </div>
          <div className="row mb-3">
            <label className="col-sm-2 col-form-label" htmlFor="lokasi">
              Lokasi
            </label>
            <div className="col-sm-10">
              <input value={values.lokasi} onChange={(e) => dispatch({ type: "lokasi", value: e.target.value })} type="text" className="form-control" id="lokasi" />
            </div>
          </div>
          <div className="row mb-3">
            <label className="col-sm-2 col-form-label" htmlFor="Instructor">
              Instructor
            </label>
            <div className="col-sm-10">
              <input value={values.instructor} onChange={(e) => dispatch({ type: "instructor", value: e.target.value })} type="text" className="form-control" id="Instructor" />
            </div>
          </div>
          {uk.length > 1 && <UkListSelector onChange={(val) => dispatch({ type: "selectedUk", value: val })} uk={uk} />}
        </ModalBody>
        <ModalFooter>
          <button disabled={submitDisable} onClick={() => submitClick(values)} type="button" className="btn btn-outline-theme">
            Generate
          </button>
        </ModalFooter>
      </Modal>
    </>
  );
}

export default ModalAmiReport;

function UkListSelector({ uk, onChange = () => {} }) {
  const handleChangeUk = (index) => {
    onChange(index);
  };
  return (
    <>
      <hr />
      <div className="form-group mb-3">
        <div className="form-group mb-3">
          <div className="col-xl-12">
            <div className="small text-theme mb-1">
              <b>Select a competency</b>
            </div>
            <div className="form-group mb-1">
              {uk.map((val) => (
                <div key={val.id} className="form-check">
                  <input className="form-check-input" onChange={() => handleChangeUk(val.id)} type="radio" name="radio_1" />
                  <label className="form-check-label">{val.title.title}</label>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
